$(document).ready(function(){

    /*submitting*/
    $('form.handlethis').submit(function(e){

        e.preventDefault();

        /*prepare*/
        const trigger = $(this).children('button');
        trigger.html(trigger.attr('sending'));

        /*create form data*/
        var data = new FormData($(this)[0]);

        /*add metas*/
        data.append('subject',trigger.attr('subject'));
        data.append('receiver',trigger.attr('receiver'));

        /*post*/
        $.ajax({
            type: 'POST',
            url: './theme/public/assets/handler/form.handle.php',
            data: data,
            async: true,
            cache: false,
            contentType: false,
            processData: false,
            success: function(reply){

                /*feedback*/
                if(reply == 'ok'){
                    trigger.html(trigger.attr('success'));
                    trigger.prop('disabled', true);

                    if(tracking){
                        gtag('event', 'form_send', {
                            'form_subject': trigger.attr('subject')
                        });
                        console.log('event sent');
                    }

                    setTimeout(function(){
                        $('form.handlethis').each(function() {
                            this.reset();
                            $('form.handlethis').find('select').prop('selectedIndex', 0);
                            $('form.handlethis').find('input:not([readonly]):not([type="hidden"]), textarea').each(function() {
                                $(this).val('').focus().blur();
                            });
                            trigger.prop('disabled', false);
                            trigger.html(trigger.attr('label'));
                        });
                    }, 6500);

                }else{
                    trigger.html(trigger.attr('error'));
                }

            }

        });

    });

});
